class ProductCardV2 extends HTMLElement {
    constructor() {
        super();
        this.slider = null;
        console.log('test');
        // Render product subtitle
        var all_product__subtitle = document.querySelectorAll(`.product-card-v2__subtitle`);
        if(all_product__subtitle && all_product__subtitle.length > 0){
            all_product__subtitle.forEach(element => {
                var product__subtitle_description = element.getAttribute('data-description');
                if(product__subtitle_description != ''){
                    element.innerText = product__subtitle_description;
                }
            });
        }
        // Render product badge
        var all_product__badge = document.querySelectorAll(`.product-card-v2__badge-text`);
        if(all_product__badge && all_product__badge.length > 0){
            all_product__badge.forEach(element => {
                var product__badge_text = element.getAttribute('data-badge');
                if(product__badge_text != ''){
                    element.innerText = product__badge_text;
                }
            });
        }
    }
    connectedCallback() {
        const swiperId = this.dataset.productId;
        const productCard = this;
        this.slider = new Swiper(`.swiper--${swiperId}`, {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: productCard.querySelector('.product-card-v2__button--next'),
                prevEl: productCard.querySelector('.product-card-v2__button--prev'),
            },
            pagination: {
                el: `.swiper--${swiperId} .swiper-pagination`,
                clickable: true,
                // dynamicBullets: true,
                // dynamicMainBullets: 1,
            },
        });
        const swatches = productCard.querySelectorAll('[data-color-swatch]');
        if (!swatches.length) return;
        swatches.forEach((swatch) => {
            swatch.addEventListener('click', () => {
                const colorValue = swatch.dataset.colorSwatch;
                const index = Array.from(this.slider.slides).findIndex(
                    (slide) => slide.dataset.colorValue === colorValue
                );
                if (index !== -1) {
                    this.slider.slideTo(index);
                }
            });
        });
        this.slider.on('slideChange', () => {
            swatches.forEach((swatch) => swatch.classList.remove('product-card-v2__color-swatch--active'));
            const activeSlide = this.slider.slides[this.slider.activeIndex];
            const activeColor = activeSlide?.dataset.colorValue;
            swatches.forEach((swatch) => {
                if (swatch.dataset.colorSwatch === activeColor) {
                    swatch.classList.add('product-card-v2__color-swatch--active');
                }
            });
        });
    }
}
customElements.define('product-card-v2', ProductCardV2);